module.exports = __webpack_public_path__ + "img/cameragreen.41c567ff.svg";